import ContentItems from 'app/modules/ContentItems';

export default ContentItems;
